module.exports = {
  "id": "spawn",
  "color": "orange",
  "title": "spawn",
  "icon": "shuffle",
  "category": "clone",
  "description": "Change the level number when one piece touches another.",
  "exposedVariables": [
    {
      "variableName": "number to spawn",
      "spriteName": "$glitch_target",
      "tooltip":"Set the number of clones to spawn",
      "input": {
        "type": "slider",
        "min": "0",
        "max": "999",
        "value": "1",
        "step": "1"
      },
      "value": "999"
    },
    {
      "variableName": "piece to spawn from",
      "spriteName": "$glitch_target",
      "tooltip":"Set the location clones will spawn from. The location must be a piece",
      "input": {
        "type": "sprite",
        "min": "0",
        "max": "20",
        "value": "5",
        "step": ".1",
        "options": []
      },
      "value": "none"
    },
    {
      "variableName": "spawn delay",
      "spriteName": "$glitch_target",
      "tooltip":"Set the amount of time between spawns",
      "input": {
        "type": "slider",
        "min": ".1",
        "max": "10",
        "value": "1",
        "step": ".1"
      },
      "value": "1"
    }
  ],
  "info": [
    {
      "text": "Create a stream of clones of a piece",
      "image": "provision/glitches/spawn/spawn.gif"
    }
  ],
  "codeImage": "provision/glitches/traffic/traffic.png",
  "code": null,
  "zip": null,
  "sb3": null,
  "image": "provision/parts/spawn/spawn.svg",
  "isRemix": true
}
;